module.exports = __webpack_public_path__ + "static/img/next_btn.8d453b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guess_word/next_btn.png
// module id = 0vH2
// module chunks = 1